module.exports = __webpack_public_path__ + "media/images/mywork logo whitebg rect retina transp-9ceef23e.png";